import React, { FC, HTMLProps } from 'react';
import styles from './notification_link.module.scss';
import { Hyperlink } from '../../../../components/Hyperlink';

type Props = HTMLProps<HTMLAnchorElement> & { source?: string };

export const NotificationLink: FC<Props> = ({ children, ...props }) => (
  <Hyperlink {...props} className={styles.container}>
    {children}
  </Hyperlink>
);
